import * as yup from "yup";

import * as RHFgeneralValidationRules from "@/utils/validation/schemas/general.RHF";
import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

import { StoreSchema } from "../Form/RHF/FormFields/StoreField/storeField.schema";

export const SubscriptionFormValidationSchema = yup
    .object({
        email: RHFUserValidationRules.emailWithNB,
        firstName: RHFUserValidationRules.optionalFirstName,
        lastName: RHFUserValidationRules.optionalLastName,
        storeId: RHFgeneralValidationRules.storeId
    })
    .concat(StoreSchema);

export type SubscriptionFormValues = yup.InferType<
    typeof SubscriptionFormValidationSchema
>;
